import { TransformDate } from '../../../shared/decorators/transform-date.decorator';
import { TransformInt } from '../../../shared/decorators/transform-int.decorator';

/**
 * Lease filebox records request DTO
 */
export class LeaseFileboxRecordsRequest {
	leasedBy!: string;
	@TransformDate()
	leasedUntil!: Date;
	@TransformInt()
	batch!: number;
	@TransformInt()
	maxRetryCount!: number;
}
